import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function saveStep(entregasTrecho, ciclo_id) {
  //entregasTrecho: { delivery_id, tp_id, step }[]
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlPostTecho(ciclo_id, user_id), entregasTrecho)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveStepPadroes(ciclo_id) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlPostTechoPadroes(ciclo_id, user_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getDeliveriesWithStepsByCycle(ciclo_id) {
  try {
    const response = await authHttp().get(routes.urlGetTechosByCicloId(ciclo_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function deleteStep(step_id) {
  try {
    const response = await authHttp().delete(routes.urlDeleteTecho(step_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function removerTrechos(ciclo_id) {
  try {
    const response = await authHttp().delete(routes.urlRemoverTrechos(ciclo_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function removerTrechosSelecionados(ciclo_id, deliveriesIds) {
  try {
    const response = await authHttp().delete(routes.urlRemoverTrechosSelecionados(ciclo_id), {
      data: deliveriesIds,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function removerEntregas(deliveriesIds) {
  try {
    await authHttp().post(routes.urlRemoverEntregas, deliveriesIds)
  } catch (error) {
    throw errorHandler(error)
  }
}
